// extracted by mini-css-extract-plugin
export default {"mainContainer":"NotFound_mainContainer__gLUBb"};